import PageHero from "../components/PageHero";
import CtaBanner from "../components/CtaBanner";
import QuoteForm from "../components/QuoteForm";
import { Reveal } from "../components/Reveal";
import { kitchenImage, galleryImages } from "../data/site";

const OutdoorKitchens = () => (
  <div data-testid="outdoor-kitchens-page">
    <PageHero
      overline="Outdoor Kitchens"
      title="Transform your outdoor space with Fresh Landscaping."
      subtitle="Custom, climate-ready outdoor kitchens designed in 3D and built for the way you entertain."
      image={kitchenImage}
    />

    <section className="py-24 md:py-32 bg-bone">
      <div className="container-fl grid md:grid-cols-12 gap-12 md:gap-20 items-center">
        <Reveal className="md:col-span-7">
          <p className="overline mb-5">Our Custom Outdoor Kitchens</p>
          <h2 className="text-4xl md:text-5xl leading-tight mb-6">The ultimate gathering place, in your own backyard.</h2>
          <p className="text-lg text-moss leading-relaxed mb-5">
            Transform your backyard into the ultimate gathering place with a custom outdoor kitchen designed and built by Fresh Landscaping. Whether you're hosting family barbecues, entertaining friends, or simply enjoying evenings outdoors, we'll help create a space that's as functional as it is beautiful.
          </p>
          <p className="text-lg text-moss leading-relaxed">
            Every project begins with a detailed 3D design, allowing you to visualize your outdoor kitchen before construction begins. This collaborative design process ensures every detail — from the layout and finishes to the placement of appliances — is tailored to your lifestyle and vision.
          </p>
        </Reveal>
        <Reveal delay={0.15} className="md:col-span-5">
          <img src={galleryImages[1]} alt="Outdoor patio project" className="w-full aspect-[4/5] object-cover" />
        </Reveal>
      </div>
    </section>

    <section className="pb-24 md:pb-32 bg-bone">
      <div className="container-fl">
        <Reveal>
          <img src={kitchenImage} alt="Custom outdoor kitchen" className="w-full aspect-[16/9] object-cover" />
        </Reveal>
        <Reveal delay={0.1} className="max-w-3xl mt-12">
          <p className="overline mb-4">Built for the Canadian climate</p>
          <p className="text-lg text-moss leading-relaxed">
            Built with durable, cost-effective aluminum cabinetry, our outdoor kitchens are designed to withstand the Canadian climate while maintaining a sleek, modern appearance. We can incorporate premium barbecues, smokers, refrigerators, storage solutions, sinks, pizza ovens, beverage centres, and virtually any feature needed to create your perfect outdoor entertaining space.
          </p>
        </Reveal>
      </div>
    </section>

    <section className="py-24 md:py-28 bg-sand">
      <div className="container-fl grid md:grid-cols-12 gap-14">
        <Reveal className="md:col-span-5">
          <p className="overline mb-5">Get Started Today</p>
          <h2 className="text-4xl md:text-5xl leading-tight">Ready to design your kitchen?</h2>
          <p className="mt-6 text-lg text-moss">Reach out to us with your needs and ideas and our team of experts will begin your outdoor kitchen design.</p>
        </Reveal>
        <Reveal delay={0.1} className="md:col-span-7 bg-white p-8 md:p-12 border border-line">
          <QuoteForm defaultService="Outdoor Kitchens" />
        </Reveal>
      </div>
    </section>

    <CtaBanner title="Let's build your dream outdoor kitchen." />
  </div>
);

export default OutdoorKitchens;
